import React, { useRef, useState } from 'react'
import { MenuFlyout, MenuItem, StyledMenuIcon, StyledMenuButton } from './styled'
import { Info, Code, MessageCircle } from 'react-feather'
import { useOnClickOutside } from 'hooks/useOnClickOutside'

function Menu(): JSX.Element {
  const menuBtnNode = useRef(null)
  const [open, setOpen] = useState(false)
  const menuToggler = () => setOpen(prev => !prev)

  useOnClickOutside(menuBtnNode, open ? menuToggler : undefined)

  return (
    <div ref={menuBtnNode}>
      <StyledMenuButton onClick={menuToggler}>
        <StyledMenuIcon />
      </StyledMenuButton>
      {open && (
        <div style={{ position: 'relative' }}>
          <MenuFlyout>
            <MenuItem href="https://boxswap.io/">
              <Info size={14} />
              About
            </MenuItem>
            <MenuItem href="https://github.com/BoxSwap">
              <Code size={14} />
              Code
            </MenuItem>
            <MenuItem href="https://discord.gg/axie">
              <MessageCircle size={14} />
              Discord
            </MenuItem>
          </MenuFlyout>
        </div>
      )}
    </div>
  )
}

export default Menu
